
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/contractor-management/[uid]",
      function () {
        return require("private-next-pages/services/contractor-management/[uid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/contractor-management/[uid]"])
      });
    }
  